import { useEffect, useState } from "react";
import { OrderStatusEnum } from "src/enums/order.enum";
import {
  orderDrawerPrimaryButtonClass,
  orderDrawerSecondaryButtonClass,
} from "src/constants/orderDrawerButtons";
import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";
import { OrderStatusMenuSelect } from "src/components/common/OrderStatusMenuSelect";

/** Batch status choices (OPEN → READY → CLOSED; excludes VOID — use single-order flow for void). */
const BATCH_ALLOWED_STATUSES: OrderStatusEnum[] = [
  OrderStatusEnum.OPEN,
  OrderStatusEnum.READY,
  OrderStatusEnum.CLOSED,
];

export interface BatchUpdateStatusPickerModalProps {
  open: boolean;
  onClose: () => void;
  onApply: (status: OrderStatusEnum) => void;
}

export function BatchUpdateStatusPickerModal({ open, onClose, onApply }: BatchUpdateStatusPickerModalProps) {
  const [selected, setSelected] = useState<OrderStatusEnum>(OrderStatusEnum.OPEN);

  useEffect(() => {
    if (open) setSelected(OrderStatusEnum.OPEN);
  }, [open]);

  if (!open) return null;

  return (
    <PortaledModalFrame
      onClose={onClose}
      panelClassName="max-w-md !overflow-visible"
      panelStyle={{ maxWidth: 420 }}
    >
      <div className="px-6 py-5">
        <h2 id="modal-title" className="text-lg font-semibold text-[#111827]">
          Batch update status
        </h2>
        <p className="mt-2 text-sm text-[#6B7280]">
          Choose the order status to apply to all selected orders.
        </p>
        <div className="mt-4">
          <p className="text-[13px] font-medium text-[#4b5563] mb-1.5">New status</p>
          <OrderStatusMenuSelect
            value={selected}
            onChange={setSelected}
            allowedStatuses={BATCH_ALLOWED_STATUSES}
            fullWidth
            ariaLabel="Order status for batch update"
          />
        </div>
        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button type="button" onClick={onClose} className={orderDrawerSecondaryButtonClass}>
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onApply(selected)}
            className={orderDrawerPrimaryButtonClass}
          >
            Apply
          </button>
        </div>
      </div>
    </PortaledModalFrame>
  );
}
